import VerifyIdentity from './VerifyIdentity';

export default VerifyIdentity;
